var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isActiveContainer,
          expression: "isActiveContainer"
        }
      ],
      staticClass: "fixed inset-y-0 z-50 w-full"
    },
    [
      _c(
        "transition",
        {
          attrs: { name: "fade", mode: "out-in" },
          on: { "after-leave": _vm.afterLeaveBG }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActiveBG,
                  expression: "isActiveBG"
                }
              ],
              staticClass: "absolute w-full h-screen bg-black bg-opacity-25",
              on: {
                click: function($event) {
                  if ($event.target !== $event.currentTarget) {
                    return null
                  }
                  _vm.isActive = false
                }
              }
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "flex items-center justify-center w-10 h-10 mt-8 ml-4 transition-colors duration-200 bg-white rounded-full md:hidden hover:text-dark text-gray-2 focus:outline-none focus:shadow-outline",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      _vm.isActive = false
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    },
                    [
                      _c("line", {
                        attrs: { x1: "18", y1: "6", x2: "6", y2: "18" }
                      }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: { x1: "6", y1: "6", x2: "18", y2: "18" }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-fade" }, on: { leave: _vm.leave } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isActive,
                  expression: "isActive"
                }
              ],
              staticClass:
                "absolute right-0 flex flex-col w-full ml-auto hover-menu h-screen-fix",
              on: {
                mouseenter: function($event) {
                  _vm.isActive = true
                },
                mouseleave: function($event) {
                  _vm.isActive = false
                }
              }
            },
            [_vm._t("default")],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }